import { useState } from 'react';
import { useAddForceSync } from '.';
import getDefaultGridState from '../../../core/types/common/DefaultGridState';
import { useToastify } from '../../../../Hooks';

export enum ETriggerResponse {
    AlreadyRunning = 1,
    Ok,
    AlreadyTriggered,
    NotFound,
    NotConfigurationFound,
}

const useForceSync = () => {
    const [forceSyncDialogActive, setForceSyncDialogActive] = useState(false);

    const { addForceSyncMutation } = useAddForceSync();
    const { showToastError, showToastSuccess, showToastWarning } = useToastify();

    const handleOnClick = (relaticsConfigurationFolderId: any, setGridState?: any) => {
        addForceSyncMutation.mutate(relaticsConfigurationFolderId, {
            onSuccess: (result) => {
                switch (result) {
                    case ETriggerResponse.Ok:
                        showToastSuccess(`A full sync has been triggered!`);
                        if (setGridState !== undefined) {
                            setGridState(getDefaultGridState());
                        }
                        break;
                    case ETriggerResponse.AlreadyRunning:
                        showToastWarning(`A full sync already running.`);
                        break;
                    case ETriggerResponse.AlreadyTriggered:
                        showToastWarning(`A full sync has already been triggered.`);

                        break;
                    case ETriggerResponse.NotFound:
                        showToastWarning(`Configuration not found`);
                        break;
                    case ETriggerResponse.NotConfigurationFound:
                        showToastError(`Configuration is empty`);
                        break;
                    default:
                        break;
                }
                setForceSyncDialogActive(!forceSyncDialogActive);
            },
        });
    };
    return { handleOnClick, forceSyncDialogActive, setForceSyncDialogActive };
};

export default useForceSync;
